import Dashboard from "@mui/icons-material/Dashboard";
import Opacity from "@mui/icons-material/Opacity";
import Construction from "@mui/icons-material/Construction";
import WebAsset from "@mui/icons-material/WebAsset";
import DvrIcon from "@mui/icons-material/Dvr";
import Settings from "@mui/icons-material/Settings";
import WavesIcon from "@mui/icons-material/Waves";
import BuildIcon from "@mui/icons-material/Build";
import {
  Download,
  FormatListBulleted,
  Logout,
  TrendingUpSharp,
} from "@mui/icons-material";

export interface INavMenuItem {
  label: string;
  icon: any;
  path: string;
  adminOnly?: boolean;
}

export const APP_NAV_MENU_ITEMS: INavMenuItem[] = [
  {
    label: "Dashboard",
    icon: <Dashboard />,
    path: "/dashboard",
  },
  {
    label: "Trends",
    icon: <TrendingUpSharp />,
    path: "/trends",
  },
  {
    label: "Download",
    icon: <Download />,
    path: "/download",
  },
  {
    label: "Auxiliary data",
    icon: <WebAsset />,
    path: "/file-browser",
  },
  {
    label: "Oil Quality",
    icon: <Opacity />,
    path: "/oil",
  },
  {
    label: "Configuration",
    icon: <Settings />,
    path: "/configuration",
  },
  {
    label: "Logs",
    icon: <FormatListBulleted />,
    path: "/logs",
    // adminOnly: true
  },
  {
    label: "System Configuration",
    icon: <DvrIcon />,
    path: "/systemconfiguration",
  },
  {
    label: "Signal",
    icon: <WavesIcon />,
    path: "/signal",
  },
  {
    label: "Settings",
    icon: <Construction />,
    path: "/settings",
  },
  {
    label: "Tool Page",
    icon: <BuildIcon />,
    path: "/tool",
  },
  {
    label: "Logout",
    icon: <Logout />,
    path: "/logout",
  },
];

export const licenseActions = {
  REVOKED: "Revoked",
  RENEWED: "Renewed",
  IMPORTED: "Imported",
};
